module.exports = __webpack_public_path__ + "static/media/canvas-export.53cf6c51.png";